/* Tysk katalog for locale-no.js (del 8 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'po.todaysPlanBase': 'Heutiger Plan — der Ausgangspunkt',
  'po.editTodaysPlan': 'Heutigen Plan bearbeiten',
  'po.netWealthToday': 'Nettovermögen heute',
  'po.monthlySavingShort': 'Monatliches Sparen',
  'po.extraDebtRepayment': 'Zusätzliche Schuldentilgung',
  'po.return': 'Rendite',
  'po.retirementAge': 'Rentenalter',
  'po.adjustAssumptions': 'Annahmen anpassen',
  'po.lifeEvents': 'Lebensereignisse',
  'po.lifeEventsSub': 'Plane große Ereignisse — Kinder, Wohnen, Elternzeit, Sabbatical — und sieh, wie sie das gesamte Zukunftsbild prägen',
  'po.addEvent': 'Ereignis hinzufügen',
  'po.lifeEventsHelp': 'Erfasse künftige Ereignisse mit Startdatum, einmaligen Kosten, monatlicher Wirkung und Dauer. Jedes aktive Ereignis wird zum richtigen Zeitpunkt in die Prognose eingefügt. Schalte ein Ereignis aus, um den Plan ohne es zu sehen. Die Ereignisse werden für das gewählte Jahr gespeichert.',
  'po.effectOver5Years': 'Wirkung über 5 Jahre',
  'po.goalScore': 'Zielscore',
  'po.goalScoreSub': 'Wie gut du auf Kurs bist, deine Ziele zu erreichen — und was den Score erhöht',
  'po.whatAffectsGoalScore': 'Das beeinflusst den Zielscore',
  'po.myRecommendationNow': 'Meine Empfehlung im Moment',
  'po.prioritise': 'Priorisieren',
  'po.talkAboutPlan': 'Sprich mit mir über den Plan',
  'po.yourGoals': 'Deine Ziele',
  'po.yourGoalsSub': 'Jedes Ziel mit Restbetrag, erwartetem Datum und Wahrscheinlichkeit',
  'po.newGoal': 'Neues Ziel',
  'po.addGoal': 'Ziel hinzufügen',
  'po.editGoal': 'Ziel bearbeiten',
  'po.deleteGoal': 'Ziel löschen',
  'po.remaining': 'Übrig',
  'po.expectedDone': 'Voraussichtlich erreicht',
  'po.probability': 'Wahrscheinlichkeit',
  'po.largestEffect': 'Größte Wirkung',
  'po.howReachFaster': 'Was kann ich tun, um das schneller zu erreichen?',
  'po.nextMilestone': 'Nächster Meilenstein',
  'po.nextMilestoneSub': 'Was du wahrscheinlich zuerst erreichst — in chronologischer Reihenfolge',
  'po.yourLifePlan': 'Dein Lebensplan',
  'po.yourLifePlanSub': 'Die wichtigsten finanziellen Meilensteine, aufgebaut aus deinen Zielen und deinem Plan',
  'po.adjustLive': 'Passe die Annahmen an — Prognose, Ziele und Termine werden in Echtzeit aktualisiert, während du ziehst.',
  'po.deleteGoalTitle': 'Ziel löschen?',
  'po.deleteGoalConfirm': 'Ziel löschen',
  'po.doYouWantToDelete': 'Möchtest du löschen:',
  'po.ownPartnerSharedSub': 'Übersicht über eigene, partnerbezogene und gemeinsame Kosten',
  'po.you': 'Du',
  'po.partner': 'Partner',
  'po.householdSpends': 'Der Haushalt gibt aus',
  'po.reportSub': 'Monats- und Jahresberichte ansehen, vergleichen, drucken und herunterladen',
  'po.print': 'Drucken',
  'po.downloadPdf': 'PDF herunterladen',
  'po.pdfBusy': 'PDF wird erstellt …',
  'po.pdfFailed': 'Das PDF des Berichts konnte nicht erstellt werden. Versuche es erneut oder nutze Drucken.',
  'po.pdfFileName': 'privatfinanzen-bericht',
  'po.compareWith': 'Vergleichen mit',
  'po.compareHelp': 'Stelle einen früheren Zeitraum daneben, um die Veränderung zu sehen. „Aus“ zeigt nur den gewählten Zeitraum.',
  'po.ongoingPeriod': 'Laufender Zeitraum — die Zahlen sind vorläufig',
  'po.plummaSummary': 'SuperPlummas Zusammenfassung',
  'po.wentWell': 'Das lief gut',
  'po.canImprove': 'Das lässt sich verbessern',
  'po.focusNextMonth': 'Fokus im nächsten Monat:',
  'po.goDeeper': 'Willst du tiefer einsteigen? Frag mich zum Bericht.',
  'po.plummaNoticed': 'SuperPlumma ist aufgefallen',
  'po.savingsRate': 'Sparquote',
  'po.noImportedCosts': 'Keine importierten Kosten',
  'po.totalCosts': 'Summe Kosten',
  'po.whatHappensNext': 'Wie geht es weiter?',
  'po.setAsideOver12': 'In 12 Monaten zurückgelegt',
  'po.averagePerMonth': 'Durchschnitt pro Monat',
  'po.askWhatHappensNext': 'Frag mich, wie es weitergeht',
  'po.whatFiguresMean': 'Was die Zahlen bedeuten',
  'po.youHaveStated': 'Du hast angegeben, dass',
  'po.howItLooksAhead': 'So sieht es in Zukunft aus',
  'po.inSixMonths': 'In 6 Monaten',
  'po.inTwelveMonths': 'In 12 Monaten',
  'po.assetCategoryPh': 'Z. B. Immobilie',
  'po.assetsAndWealth': 'Vermögenswerte und Vermögen',
  'po.assetsAndWealthSub': 'Alles, was du besitzt, an einem Ort — Wohnung, Fahrzeuge, Ersparnisse und Investitionen',
  'po.assetsHelp': 'Der Gesamtwert deines Besitzes, deine Schulden und das Nettovermögen (Vermögenswerte minus Schulden). „Erwartete Wertänderung“ fasst zusammen, wie die Vermögenswerte im Laufe des Jahres voraussichtlich steigen oder fallen.',
  'po.totalAssets': 'Gesamte Vermögenswerte',
  'po.netWealth': 'Nettovermögen',
  'po.expectedChangePerYear': 'Erwartete Wertänderung pro Jahr',
  'po.liquid': 'Liquide (Ersparnisse und Fonds)',
  'po.assetCount': 'Anzahl Vermögenswerte',
  'po.wealthHealth': 'Vermögensgesundheit',
  'po.wealthHealthSub': 'Gesamtbewertung, wie robust dein Vermögen ist — Diversifikation, Liquidität, Risiko und Verschuldungsgrad',
  'po.wealthStrongestOn': 'Dein Vermögen schneidet am besten ab bei',
  'po.wealthDistribution': 'Wie dein Vermögen auf Kategorien verteilt ist',
  'po.expectedDevelopment': 'Erwartete Entwicklung',
  'po.expectedDevelopmentSub': 'Basierend auf der Wertänderung, die du je Vermögenswert eingegeben hast',
  'po.projectionHelp': 'Die Hochrechnung verwendet die erwartete jährliche Wertänderung, die du für jeden Vermögenswert eingegeben hast. Plumme ruft noch keine externen Marktdaten für Immobilien, Gebrauchtwagen oder Fonds ab.',
  'po.withYourAssumptions': 'Mit deinen Annahmen ändert sich dein Vermögen um etwa',
  'po.explainSimply': 'Entwicklung einfach erklären',
  'po.watchingClosely': 'Besonders im Blick',
  'po.watchingCloselySub': 'Die Vermögenswerte, die voraussichtlich an Wert verlieren oder langsamer als die Inflation wachsen',
  'po.explain': 'Erklären',
  'po.yourAssets': 'Deine Vermögenswerte',
  'po.yourAssetsSub': 'Tippe auf einen Vermögenswert, um Wert und Details zu bearbeiten',
  'po.addAsset': 'Vermögenswert hinzufügen',
  'po.askAboutTax': 'Frag mich zur Steuer',
  'po.taxAssistant': 'Assistent für die skattemelding',
  'po.taxAssistantSub': 'SuperPlumma führt dich Schritt für Schritt und passt die Fragen unterwegs an',
  'po.deductionHunter': 'Abzugsjäger',
  'po.deductionHunterSub': 'Die Abzüge sind nach erwartetem Wert sortiert — fang oben an, wo der Gewinn am größten ist',
  'po.whyIThinkThis': 'Warum denke ich das?',
  'po.dataIUsed': 'Verwendete Daten',
  'po.whyYouQualify': 'Warum dir der Abzug zusteht',
  'po.estimatedTaxBenefit': 'Geschätzter Steuervorteil',
  'po.taxOptimisation': 'Steueroptimierung',
  'po.taxOptimisationSub': 'Konkrete Maßnahmen nach Frist sortiert — und was sie für dieses und nächstes Jahr bedeuten',
  'po.nextYearOnwards': 'Nächstes Jahr und darüber hinaus',
  'po.aiTaxCheck': 'AI Steuerprüfung',
  'po.aiTaxCheckSub': 'SuperPlumma prüft deine importierten Steuerangaben',
  'po.readyToFile': 'Bereit für externe Prüfung',
  'po.readyToFileSub': 'Vergleiche die Grundlage mit der skattemelding und den Jahresbescheinigungen',
  'po.checkBasis': 'Prüfungsgrundlage',
  'po.requiresIntegration': 'Erfordert eine offizielle Integration, starke Authentifizierung und ausdrückliche Freigabe',
  'po.filingUnavailable': 'Einreichung nicht verfügbar',
  'po.whatIsMissing': 'Was fehlt noch vor der externen Prüfung?',
  'po.whatRemains': 'Das ist noch offen',
  'po.taxBasisNotFetched': 'Die Steuergrundlage wurde nicht abgerufen',
  'po.alreadyVerified': 'Bereits qualitätsgesichert',
  'po.nothingVerified': 'Noch nichts qualitätsgesichert.',
  'spx.taxScheme': 'Steuer- und Abgabenregelung',
  'spx.noItems': 'Noch keine Posten erfasst.',
  'spx.removeSpec': 'Spezifikation entfernen',
  'prd.import': 'Produkte importieren',
  'prd.excel': 'Excel (.xlsx)',
  'prd.export': 'Produkte exportieren',
  'prd.csvName': 'Produkte CSV',
  'prd.excelName': 'Produkte Excel',
  'prd.countTemplateName': 'Zählvorlage für die Inventur',
  'prd.countTemplateEmpty': 'Keine Waren zu zählen. Die Zählvorlage umfasst Produkte vom Typ Ware.',
  'prd.countTemplateDone': 'Zählvorlage heruntergeladen. Trage die Mengen zum 31.12. ein und denk daran, dass der Bestand zu Anschaffungskosten bewertet wird.',
  'prd.countTemplateError': 'Die Zählvorlage konnte nicht erstellt werden.',
  'prd.colProductId': 'Produkt-ID',
  'prd.colInventoryAccount': 'Bestandskonto',
  'prd.colStockToday': 'Bestand heute',
  'prd.colCountedQuantity': 'Gezählte Menge',
  'prd.colTotalCostValue': 'Gesamter Kostenwert',
  'prd.colNote': 'Anmerkung',
  'prd.countSheetTitle': 'Inventur',
  'prd.countSheetIntro': 'Menge und Wareneinsatz sind aus dem heutigen Produktregister vorausgefüllt. Prüfe und korrigiere sie anhand der tatsächlichen Zählung am Zähldatum.',
  'prd.countSheetDate': 'Zähldatum',
  'prd.countSheetCountedBy': 'Gezählt von',
  'prd.countSheetReference': 'Referenz',
  'prd.countSheetSignature': 'Unterschrift',
  'prd.countSheetNoteLabel': 'Hinweis',
  'prd.countSheetNote': 'Diese Liste dokumentiert die Zählung. Buchwert und steuerlicher Wert werden bei den Jahresabschlussarbeiten beurteilt.',
  'prd.countSheetInfoTab': 'Informationen',
  'prd.countSheetWrongTemplate': 'Verwende die Zählvorlage von Plumme. Die Spalten stimmen nicht überein.',
  'prd.countSheetOnlyXlsx': 'Der automatische Import unterstützt die Excel-Vorlage (.xlsx). Andere Dateien werden als Dokumentation gespeichert.',
  'prd.countSheetTabNotFound': 'Das Blatt {name} wurde nicht gefunden.',
  'prd.countSheetRowError': 'Zeile {row}: Prüfe Ware, Bestandskonto, gezählte Menge und Wareneinsatz.',
  'prd.countSheetNoneCounted': 'In der Zählliste wurden keine ausgefüllten Mengen gefunden.',
  'prd.countSheetUnmappedAccount': 'Bestandskonto {account} kann nicht automatisch zugeordnet werden. Prüfe die Konten in der Durchsicht.',
  'prd.filterHelp': 'Filtere die Produkte nach Typ (Ware, Dienstleistung, Vermietung), nach Lagerbestand und danach, ob gelöschte angezeigt werden.',
  'prd.listTitle': 'Produktliste',
  'prd.listSub': 'Waren und Dienstleistungen, die du verkaufst',
  'prd.new': 'Neues Produkt',
  'prd.searchPh': 'Nach Produktname, Beschreibung, Artikelnummer oder Preis suchen',
  'prd.searchHelp': 'Nach Produktname, Beschreibung, Artikelnummer oder Preis suchen.',
  'prd.none': 'Noch keine Produkte vorhanden',
  'prd.listHelpTitle': 'Die Produktliste',
  'prd.listHelp': 'Jede Zeile ist ein Produkt mit Artikelnr., Preis, MwSt.-Satz, Typ und Lagerbestand. Tippe auf eine Zeile, um Details zu sehen und zu bearbeiten.',
  'prd.detailsTitle': 'Produktdetails',
  'prd.detailsHelp': 'Beschreibung, Artikelnummer, Preis ohne MwSt., MwSt.-Satz, Typ und Lagerbestand des Produkts.',
  'prd.editHelp': 'Ändere Name, Preis, MwSt., Typ und Lager des Produkts.',
  'prd.delete': 'Produkt löschen',
  'prd.deleteHelp': 'Verschiebe das Produkt zu den gelöschten. Du kannst es später wiederherstellen.',
  'prd.itemNo': 'Artikelnr.',
  'prd.colStockItem': 'Ware',
  'prd.stockReasonDefault': 'Körperliche Zählung',
  'prd.stock': 'Lager',
  'prd.deleted': 'Gelöscht',
  'prd.pickOwnColour': 'Eigene Farbe wählen',
  'prd.namePh': 'Z. B. Beratungsstunde',
  'prd.priceExVat': 'Preis ohne MwSt.',
  'prd.price': 'Preis',
  'prd.priceIncVat': 'Preis inkl. MwSt.',
  'prd.subscriptionPeriod': 'Abonnementzeitraum',
  'prd.multiDayDiscount': 'Mehrtagesrabatt',
  'prd.multiDayHelp': 'Gilt nur für dieses Mietprodukt.',
  'prd.day2ChargedAt': 'Tag 2 wird berechnet mit',
  'prd.day3Onwards': 'Ab Tag 3',
  'prd.itemNumber': 'Artikelnummer',
  'prd.accountFallbackName': 'Konto',
  'prd.acct3000': 'Verkauf und Entnahme, mehrwertsteuerpflichtig',
  'prd.acct3020': 'Umsatzerlöse Dienstleistungen, hoher MwSt.-Satz',
  'prd.acct3030': 'Umsatzerlöse Waren, mittlerer MwSt.-Satz',
  'prd.acct3050': 'Umsatzerlöse Waren, niedriger MwSt.-Satz',
  'prd.acct3100': 'Verkauf und Entnahme mit 0 Prozent MwSt.',
  'prd.acct3200': 'Verkauf und Entnahme außerhalb des MwSt.-Gesetzes',
  'prd.acct3900': 'Sonstige betriebliche Erträge',
  'prd.colProductName': 'Produktname',
  'prd.colDescription': 'Beschreibung',
  'prd.colVat': 'MwSt.',
  'prd.colType': 'Typ',
  'prd.colRentalDiscount': 'Mietrabatt',
  'prd.colSalesAccount': 'Erlöskonto',
  'prd.colEquivalentAccount': 'Entspricht Standardkonto',
  'prd.excelImportUnavailable': 'Excel-Import ist noch nicht verfügbar.',
  'prd.excelExportUnavailable': 'Excel-Export ist noch nicht verfügbar.',
  'prd.colStatus': 'Status',
  'prd.exportSheetName': 'Produkte',
  'prd.typeHeading': 'Überschrift',
  'prd.typeTextLine': 'Textzeile',
  'prd.textLinesTitle': 'Textzeilen',
  'prd.newTextLine': 'Neue Textzeile',
  'prd.updateTextLine': 'Textzeile aktualisieren',
  'prd.saveTextLine': 'Textzeile speichern',
  'prd.textLineNamePh': 'Z. B. Standard-Montagetext',
  'prd.textLineTextPh': 'Schreib den Text, der auf Dokumentzeilen verwendet werden soll',
  'prd.styleFor': 'Stil für {target}',
  'prd.styleTargetText': 'Text',
  'prd.styleTargetName': 'Name',
  'prd.styleBold': 'Fett',
  'prd.styleItalic': 'Kursiv',
  'prd.styleDivider': 'Trennlinie',
  'prd.styleNoDivider': 'Ohne Trennlinie',
  'prd.styleSummary': 'Name: {name} · Text: {text} · {divider}',
  'prd.toastProductUpdated': 'Produkt aktualisiert',
  'prd.toastProductSaved': 'Produkt gespeichert',
  'prd.toastProductSaveError': 'Das Produkt konnte nicht gespeichert werden.',
  'prd.toastProductDeleted': 'Produkt gelöscht',
  'prd.toastProductDeleteError': 'Das Produkt konnte nicht gelöscht werden.',
  'prd.toastTextLineUpdated': 'Textzeile aktualisiert',
  'prd.toastTextLineSaved': 'Textzeile gespeichert',
  'prd.toastTextLineSaveError': 'Die Textzeile konnte nicht gespeichert werden.',
  'prd.toastTextLineDeleted': 'Textzeile gelöscht',
  'prd.toastTextLineDeleteError': 'Die Textzeile konnte nicht gelöscht werden.',
  'prd.toastImportNoneFound': 'In der Datei wurden keine Produkte gefunden.',
  'prd.toastImportSuccess': '{count} Produkte importiert',
  'prd.toastImportError': 'Produkte konnten nicht importiert werden.',
  'prd.toastExportNone': 'Keine Produkte zum Exportieren',
  'prd.toastExportDone': 'Produktliste heruntergeladen',
  'prd.toastExportError': 'Die Produktliste konnte nicht exportiert werden.',
  'prd.textLineFilterHelp': 'Filtere gespeicherte Textzeilen und Überschriften.',
  'prd.filterOther': 'Sonstiges',
  'prd.showDeleted': 'Gelöschte anzeigen',
  'prd.typeGoods': 'Ware',
  'prd.typeService': 'Dienstleistung',
  'prd.typeRental': 'Vermietung',
  'prd.typeSubscription': 'Abonnement',
  'prd.stockOnly': 'Nur auf Lager',
  'prd.textLineSubtitle': 'Gespeicherte Texte und Überschriften für Verkaufsdokumente',
  'prd.titleHelp': 'Deine Produkte — Waren und Dienstleistungen, die du verkaufst, mit Preis, MwSt. und Lager. Tippe auf ein Produkt für Details.',
  'prd.uploadHelp': 'Produkte aus einer Datei importieren.',
  'prd.downloadHelp': 'Lade die Produktliste als CSV oder Excel herunter.',
  'prd.addHelp': 'Füge eine neue Ware, Dienstleistung, ein Abonnement oder ein Mietprodukt hinzu.',
  'prd.textLineSearchPh': 'Nach Name, Text oder Typ suchen',
  'prd.textLineSearchHelp': 'In gespeicherten Textzeilen und Überschriften suchen.',
  'prd.emptyText': 'Füge die Waren und Dienstleistungen hinzu, die du verkaufst, dann geht die Rechnungsstellung blitzschnell.',
  'prd.textLineEmptyTitle': 'Noch keine Textzeilen',
  'prd.textLineEmptyText': 'Speichere feste Texte, Überschriften und Produkttexte ohne Preis.',
  'prd.colBalance': 'Bestand',
  'prd.colCostPerUnit': 'Wareneinsatz pro Einheit',
  'prd.colTotalValue': 'Gesamtwert',
  'prd.colStockAvailable': 'Lager/verfügbar',
  'prd.noneShort': 'Keine',
  'prd.subscriptionLabel': 'Abonnement · {period}',
  'prd.month1Short': '1 Mon.',
  'prd.months12Short': '12 Mon.',
  'prd.copyToTextLine': 'In Textzeile kopieren',
  'prd.colProduct': 'Produkt',
  'prd.colPrice': 'Preis',
  'prd.colName': 'Name',
  'prd.colStyle': 'Stil',
  'prd.errNrTaken': 'Die Artikelnummer „{nr}“ wird bereits verwendet.',
  'prd.errAccountCodeFormat': 'Verwende ein Ertragskonto, das mit 3 beginnt und 4 oder 5 Ziffern hat.',
  'prd.errAccountNameRequired': 'Gib dem Konto einen Namen.',
  'prd.errAccountEquivalentRequired': 'Wähle das Standardkonto, dem dieses entsprechen soll.',
  'prd.errAccountExists': 'Konto {code} existiert bereits.',
  'prd.errCostPriceInvalid': 'Der Einstandspreis muss ein gültiger Betrag von mindestens 0 sein.',
  'prd.errTrackingDateRequired': 'Wähle das Datum, ab dem die automatische Lagerverwaltung starten soll.',
  'prd.errStockNegative': 'Der Anfangsbestand darf nicht negativ sein.',
  'prd.errCostPriceRequired': 'Gib einen Einstandspreis für den Anfangsbestand ein.',
  'prd.errCostPriceNegative': 'Der Einstandspreis darf nicht negativ sein.',
  'prd.noName': 'Ohne Namen',
  'prd.updateProduct': 'Produkt aktualisieren',
  'prd.saveProduct': 'Produkt speichern',
  'prd.rentalQtyLabel': 'Zur Vermietung verfügbare Menge',
  'prd.autoInventoryTitle': 'Automatischer Lagerbestand und Warenkosten',
  'prd.autoInventoryHelp': 'Einkäufe erhöhen den Bestand. Gebuchte Verkäufe verringern den Bestand und buchen die berechneten Warenkosten nach gewogenem Durchschnitt.',
  'prd.calculatedStock': 'Berechneter Lagerbestand',
  'prd.openingStock': 'Anfangsbestand',
  'prd.avgCostPrice': 'Durchschnittlicher Einstandspreis',
  'prd.costPerUnit': 'Einstandspreis pro Einheit',
  'prd.inventoryValueLine': 'Lagerwert: {value}',
  'prd.month1': '1 Monat',
  'prd.months12': '12 Monate',
  'prd.advancedTitle': 'Erweiterte Produktdaten',
  'prd.advancedHelp': 'SKU, EAN/GTIN, Produktgruppe und Importdaten.',
  'prd.noGroup': 'Keine Gruppe',
  'prd.removeGroup': 'Produktgruppe entfernen',
  'prd.newGroupPh': 'Neue Produktgruppe',
  'prd.brand': 'Marke',
  'prd.variantName': 'Variantenname',
  'prd.supplierItemNumber': 'Lieferanten-Artikelnr.',
  'prd.internalReference': 'Interne Referenz',
  'prd.tags': 'Tags',
  'prd.tagsPh': 'Z. B. Onlineshop, Ersatzteil, Winter',
  'prd.saveAsTextLineTitle': 'Auch als Textzeile speichern',
  'prd.saveAsTextLineHelp': 'Erstellt eine Kopie ohne Preis für Dokumentzeilen.',
  'prd.autoAccountLine': 'Automatisch: {account}',
  'prd.accountTypeLabel': 'Kontotyp',
  'prd.selectAccount': 'Konto wählen',
  'prd.customAccountOption': 'Benutzerdefiniert',
  'prd.accountInLedger': 'Konto in der Buchhaltung',
  'prd.accountNamePh': 'Weiterberechnung',
  'prd.equivalentForYearEnd': 'Entspricht für Jahresabschluss/Steuern',
  'prd.selectStandardAccount': 'Standardkonto wählen',
  'sub.tabsHelp': 'Wechsle zwischen Abonnements mit wiederkehrender Rechnungsstellung und Kundenlisten für Sammelrechnungen oder E-Mails.',
  'sub.start': 'Beginn',
  'sub.end': 'Ende',
  'sub.endHelp': 'Leer lassen, um fortzufahren, bis das Abonnement pausiert oder gelöscht wird.',
  'sub.internalComment': 'Interner Kommentar',
  'sub.saveCustomers': 'Kunden speichern',
  'sub.searchCustomers': 'Kunden suchen',
  'sub.searchCustomersPh': 'Nach Name, E-Mail oder Org.-Nr. suchen...',
  'sub.selectVisible': 'Sichtbare auswählen',
  'sub.deselectVisible': 'Sichtbare abwählen',
  'sub.noCustomers': 'Noch keine Kunden',
  'sub.howToInvoice': 'Wie möchtest du abrechnen?',
  'sub.manualFlowNote': 'Die Auswahl unten startet einen manuellen Rechnungsablauf für das Abonnement.',
  'sub.sendInvoice': 'Rechnung senden',
  'sub.openDraftFilled': 'Einen Rechnungsentwurf mit bereits ausgefülltem Abonnement öffnen.',
  'sub.openBlankDraft': 'Einen leeren Rechnungsentwurf mit ausgewählter Kundengruppe öffnen.',
  'sub.subject': 'Betreff',
  'sub.message': 'Nachricht',
  'sub.removeAllAttachments': 'Alle Anhänge entfernen',
  'sub.addCustomers': 'Kunden hinzufügen',
  'sub.noInvoiceSent': 'Keine Rechnung gesendet',
  'sub.noEmailSent': 'Keine E-Mail gesendet',
  'sub.unknownCustomer': 'Unbekannter Kunde',
  'sub.customersCount': '{count} Kunden',
  'sub.cpiAnnualSuffix': ' · VPI {rate} % jährlich',
  'sub.actionMenuLabel': 'Aktion',
  'sub.nameRequiredSubscription': 'Gib dem Abonnement einen Namen',
  'sub.nameRequiredList': 'Gib der Liste einen Namen',
  'sub.nameRequiredListError': 'Gib der Liste einen Namen.',
  'sub.nameRequiredAgreementError': 'Gib der Vereinbarung einen Namen.',
  'sub.editSubTitle': 'Abonnement bearbeiten',
  'sub.editListTitle': 'Liste bearbeiten',
  'sub.newSubTitle': 'Neues Abonnement',
  'sub.newListTitle': 'Neue Liste',
  'sub.saveChanges': 'Änderungen speichern',
  'sub.saveSubscription': 'Abonnement speichern',
  'sub.saveList': 'Liste speichern',
  'sub.namePlaceholderSub': 'Z. B. Goldmitgliedschaft',
  'sub.namePlaceholderList': 'Z. B. Newsletter',
  'sub.nextInvoiceDateLabel': 'Nächstes Rechnungsdatum',
  'sub.cpiAdjustmentLabel': 'VPI-Anpassung',
  'sub.cpiAdjustmentHelp': 'Jährliche Anpassung des Abonnementpreises an den Verbraucherpreisindex.',
  'sub.customerSavedToast': 'Kunde „{name}“ gespeichert',
  'sub.saveCustomerError': 'Der Kunde konnte nicht gespeichert werden.',
  'sub.addCustomersTitle': 'Kunden hinzufügen · {name}',
  'sub.selectedCount': '{count} ausgewählt',
  'sub.addAsNewCustomer': '„{name}“ als neuen Kunden hinzufügen',
  'sub.noContactInfo': 'Keine Kontaktdaten',
  'sub.addCustomersEmptyText': 'Füge zuerst Kunden im Kundenregister hinzu oder gib einen Namen ein, um einen neuen Kunden anzulegen.',
  'sub.sendInvoiceTitle': 'Rechnung senden · {name}',
  'sub.attachmentTooLarge': 'Anhänge dürfen höchstens {max} groß sein.',
  'sub.fillSubject': 'Gib einen Betreff ein.',
  'sub.writeMessage': 'Schreib eine Nachricht.',
  'sub.sendEmailTitle': 'E-Mail senden · {name}',
  'sub.sending': 'Wird gesendet...',
  'sub.sendEmailButton': 'E-Mail senden',
  'sub.readyCount': '{count} bereit',
  'sub.attachmentsAddedCount': '{count} Anhänge hinzugefügt',
  'sub.addAttachment': 'Anhang hinzufügen',
  'sub.emailSendNote': 'E-Mails werden über das Backend gesendet. Du kannst Dateien überall im Dialog ablegen oder mit Ctrl+V einfügen. Empfänger ohne E-Mail-Adresse werden als nicht gesendet protokolliert.',
  'sub.typeSubscription': 'Abonnement',
  'sub.typeList': 'Liste',
  'sub.actionClose': 'Schließen',
  'sub.actionOpen': 'Öffnen',
  'sub.edit': 'Bearbeiten',
  'sub.emailLabel': 'E-Mail',
  'sub.resume': 'Fortsetzen',
  'sub.pause': 'Pausieren',
  'sub.delete': 'Löschen',
  'sub.tabCustomers': 'Kunden ({count})',
  'sub.tabInvoices': 'Rechnungen ({count})',
  'sub.tabEmails': 'E-Mails ({count})',
  'sub.addCustomersToInvoiceText': 'Füge Kunden hinzu, um ihnen Rechnungen zu stellen.',
  'sub.removeMember': 'Entfernen',
});
